export const BREAK_POINT_MOBILE = '576px';
export const BREAK_POINT_TABLET = '992px';
export const BREAK_POINT_DESKTOP = '1180px';
